<template>
    <div class="bloque-paginacion">
        <ul class="pagination">
            <li class="page-item" :class="{disabled: !link.url, active: link.active}"  v-for="(link, index) in links" :key="index">
                <component :is="(link.url)? 'Link' : 'span'" class="page-link" :href="link.url" v-html="link.label" />
            </li>
        </ul>
    </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';

export default {
    props: {
        links: Object,
    },
    components: { Link }
}
</script>
<style>
    .bloque-paginacion .page-item:first-child .page-link, .bloque-paginacion .page-item:last-child .page-link{
        font-size: 0;
    }
</style>
